import React from 'react';
import PropTypes from 'prop-types';
import { introspectionQueries } from '../../graphql/queries';
import BBQuery from './BBQuery.js';

// uses render props pattern - https://reactjs.org/docs/render-props.html
// in this case prop is 'children' not 'render' but its the same concept

class EnumValues extends React.Component {
  render () {
    const { children, name } = this.props;
    return (
      <BBQuery query={introspectionQueries.EnumValues(name)}>
        {data => {
          return children(data.__type.enumValues);
        }}
      </BBQuery>
    );
  }
}

EnumValues.propTypes = {
  children: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired
};

export default EnumValues;
